module.exports = __webpack_public_path__ + "static/media/1002256.4a3e689a.png";